import React, { useEffect, useState } from "react";
import { Inbox, PlayCircle, CheckCircle2 } from "lucide-react";
import ApiService from "../../helpers/Services";

const StatItem = ({ Icon, label, value, accent, loading }) => (
  <div className={`stat-item stat-item--${accent}`}>
    <div className="stat-item__icon-wrap">
      <Icon size={20} strokeWidth={1.75} />
    </div>
    <div className="stat-item__body">
      <div className="stat-item__label">{label}</div>
      <div className="stat-item__value">
        {loading ? <span className="stat-item__skeleton" /> : value}
      </div>
    </div>
  </div>
);

const StatsStrip = () => {
  const [counts, setCounts] = useState({ open: 0, inProgress: 0, complete: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await ApiService.post("get-task-list", { searchText: "" });
        if (cancelled) return;
        const next = { open: 0, inProgress: 0, complete: 0 };
        (data || []).forEach((t) => {
          const status = t.assignedto
            ? (t.status || "").includes("Assigned")
              ? "In Progress"
              : "Complete"
            : "Open";
          if (status === "Open") next.open += 1;
          else if (status === "In Progress") next.inProgress += 1;
          else if (status === "Complete") next.complete += 1;
        });
        setCounts(next);
      } catch (e) {
        // Silent — the strip is decorative; failure shouldn't crash the home page.
        console.warn("StatsStrip: get-task-list failed", e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="stats-strip">
      <StatItem
        Icon={Inbox}
        label="Open Tickets"
        value={counts.open}
        accent="teal"
        loading={loading}
      />
      <StatItem
        Icon={PlayCircle}
        label="In Progress"
        value={counts.inProgress}
        accent="amber"
        loading={loading}
      />
      <StatItem
        Icon={CheckCircle2}
        label="Completed"
        value={counts.complete}
        accent="navy"
        loading={loading}
      />
    </div>
  );
};

export default StatsStrip;
